export default {
  userStatements: (state: any) => state.statements,
  statementYears: (state: any) => state.statementYears,
  bankProvider: (state: any) => state.bank,
  financialYears: (state: any) => state.financialYears,
  authorisation: (state: any) => state.authorisation,
  swiftaidAuthorised: (state: any) => state.swiftaidAuthorised,
  authorisationStatusKnown: (state: any) =>
    Boolean(state.authorisationStatusKnown),
  user: (state: any) => state.userDetails,
  swiftaidGivingPlan: (state: any) => state.swiftaidGivingPlan ?? 'free',
  donorPlanStatusKnown: (state: any) => Boolean(state.donorPlanStatusKnown),
  isSwiftaidGivingPaid: (state: any) => state.swiftaidGivingPlan === 'paid',
  swiftaidGivingSubscription: (state: any) => state.swiftaidGivingSubscription ?? null,
  hasFullGivingRecord: (state: any) =>
    state.swiftaidGivingFeatures?.fullGivingRecord === true,
}
